<template>
    <div>
      <div v-if="cookie == false" class="tw-w-full tw-text-center tw-text-jrRed-50 tw-bg-white tw-px-2.5 tw-rounded-md tw-py-4">
        <i class="icon-warning tw-mr-3 tw-text-xs"></i>Por favor, ative seus <span class="tw-font-bold">cookies</span> para acessar essa página.<i class="icon-warning tw-ml-3 tw-text-xs"></i>
      </div>
      <div v-else class="tw-w-full tw-text-center tw-text-jrRed-50 tw-bg-white tw-px-2.5 tw-rounded-md tw-py-4">
        <i class="icon-warning tw-mr-3 tw-text-xs"></i><span class="tw-font-bold">Opss</span> , nenhum lote encontrado.<i class="tw-icon-warning tw-ml-3 tw-text-xs"></i>
        <br>
        <router-link v-show="leilaoId !== undefined" :to="'/leilao/index/leilao_id/'+leilaoId" class="tw-px-2.5 tw-py-[5px] tw-bg-jrBlue-100 tw-rounded-md tw-justify-center tw-items-center tw-gap-2.5 tw-inline-flex tw-text-white tw-mt-2">Voltar para Listagem</router-link>
        <a v-show="leilaoId == undefined" @click="backHistory"></a>
      </div>
    </div>
</template>
<script>
export default {
    name: 'NaoEncontrado',
    props: ['cookie'],
    data () {
        return {
            leilaoId: this.$route.params.id
        }
    },
    methods:{
        backHistory(){
            window.history.back()
        }
    }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/shared/NaoEncontrado.vue